import React, { useState } from 'react';
import classNames from 'classnames';

import css from './OrderPanel.module.css';

// Service-tier card for DockRampDeliveryWidget and ModifyDockRampDeliveryModal.
// Description is hidden by default; click "Details ▾" to expand. Card-as-button
// pattern uses role="button" + tabIndex={0} so the inner toggle can be a real
// <button> without nesting (which would be invalid HTML and bubble clicks to
// the outer card). Per-card local expand state — multiple cards can be
// expanded simultaneously. Expanding does NOT select the card.
const ServiceCard = ({ idx, title, subtext, price, selected, formatPrice, onSelect }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = e => {
    e.stopPropagation();
    setExpanded(prev => !prev);
  };
  const handleCardClick = () => onSelect(idx);
  const handleCardKeyDown = e => {
    // Only handle keys when the card itself is focused — not when the inner
    // toggle button is. Otherwise Enter on the toggle would bubble up here
    // and trigger card selection instead of activating the toggle.
    if (e.target !== e.currentTarget) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect(idx);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames(css.deliveryServiceCard, {
        [css.deliveryServiceCardSelected]: selected,
      })}
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
    >
      <div className={css.deliveryServiceCardLeft}>
        <span className={css.deliveryServiceCardName}>{title}</span>
        {subtext ? (
          <>
            <button
              type="button"
              className={css.deliveryServiceCardToggle}
              onClick={handleToggle}
            >
              {expanded ? 'Details ▴' : 'Details ▾'}
            </button>
            {expanded ? (
              <span className={css.deliveryServiceCardSubtext}>{subtext}</span>
            ) : null}
          </>
        ) : null}
      </div>
      <span className={css.deliveryServiceCardPrice}>{formatPrice(price)}</span>
    </div>
  );
};

export default ServiceCard;
